import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const payrollPeriodService = {
  getPeriodsByYear: async (year) => {
    return await axios.get(`${domain}/api/PayrollPeriod/year/${year}`, { headers });
  }
};